import { render, staticRenderFns } from "./FloatBtn.vue?vue&type=template&id=5082af74&scoped=true"
import script from "./FloatBtn.vue?vue&type=script&lang=js"
export * from "./FloatBtn.vue?vue&type=script&lang=js"
import style0 from "./FloatBtn.vue?vue&type=style&index=0&id=5082af74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5082af74",
  null
  
)

export default component.exports